export default "__VITE_ASSET__0431f428__"